export const columns = [
    {
        title:'参与日期',
        dataIndex:"updateTime",
        key:"updateTime",
        width: 180
    },
    {
        title:'会议名称',
        dataIndex:"meetingName",
        key:"meetingName"
    },
    {
        title:'会议人数',
        dataIndex:"meetingNumber",
        key:"meetingNumber"
    },
    {
        title:'出发地',
        dataIndex:"startingPoint",
        key:"startingPoint"
    },
    {
        title:'目的地',
        dataIndex:"destination",
        key:"destination",
    },
    {
        title:'交通方式',
        dataIndex:"transport",
        key:"transport",
        slots:"transport"
    },
    {
        title:'会议时长',
        dataIndex:"meetingSize",
        key:"meetingSize",
        slots: "meetingSize",
    },
    {
        title:'预估碳排量',
        dataIndex:"carbonEmission",
        key:"carbonEmission",
        slots:"carbonEmission"
    },
    {
        title:'碳排金额',
        dataIndex:"trueAmount",
        key:"trueAmount",
        slots:"trueAmount"
    },
    {
        title:'付款金额',
        dataIndex:"donatedAmount",
        key:"donatedAmount",
        slots:"donatedAmount"
    },
    {
        title:'证书状态',
        dataIndex:"status",
        key:"status",
        slots:"status"
    },
    {
        title: "操作",
        slots:'actions',
        width:100,
        fixed:'right'
    },
]
export const columns1 = [
    {
        title:'参与日期',
        dataIndex:"updateTime",
        key:"updateTime",
        width: 180
    },
    {
        title:'姓名/单位',
        dataIndex:"name",
        key:"name"
    },
    {
        title:'手机号',
        dataIndex:"phone",
        key:"phone"
    },
    {
        title:'出发地',
        dataIndex:"startingPoint",
        key:"startingPoint"
    },
    {
        title:'目的地',
        dataIndex:"destination",
        key:"destination",
    },
    {
        title:'交通方式',
        dataIndex:"transport",
        key:"transport",
        slots:"transport",
    },
    {
        title:'预估碳排量',
        dataIndex:"carbonEmission",
        key:"carbonEmission",
        slots:"carbonEmission",
    },
    {
        title:'碳排金额',
        dataIndex:"trueAmount",
        key:"trueAmount",
        slots:"trueAmount",
    },
    {
        title:'付款金额',
        dataIndex:"donatedAmount",
        key:"donatedAmount",
        slots:"donatedAmount",
    },
    {
        title:'证书状态',
        dataIndex:"status",
        key:"status",
        slots:"status",
    },
    {
        title: "操作",
        slots:'actions',
        width:100,
        fixed:'right'
    },
]
